import { Clock } from 'lucide-react';

/**
 * Shown to non-owner members when the workspace's setup_state is not COMPLETE.
 * They are not allowed into the owner-only setup wizard, so we show a calm
 * holding state until the owner finishes.
 */
export function WorkspaceSetupPending() {
  return (
    <div className="bg-background flex min-h-screen items-center justify-center px-6">
      <div className="border-border bg-surface w-full max-w-md rounded-2xl border p-8 text-center shadow-sm">
        <div className="bg-primary/10 text-primary mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-xl">
          <Clock className="h-6 w-6" strokeWidth={1.75} />
        </div>
        <h1 className="text-foreground text-3xl font-semibold">Workspace is being set up</h1>
        <p className="text-muted-foreground mt-2 text-xl">
          An admin is still finishing this workspace&apos;s setup. You&apos;ll get access as soon as
          it&apos;s ready — check back shortly.
        </p>
      </div>
    </div>
  );
}
